export const GLOBLE_PIN = "GLOBLE_PIN";
export const GLOBLE_PIN_ERROR = "GLOBLE_PIN_ERROR";
export const GLOBLE_PIN_HIDE_ERROR = "GLOBLE_PIN_HIDE_ERROR";
export const GLOBLE_PIN_START_LOADER = "GLOBLE_PIN_START_LOADER";
export const GLOBLE_PIN_STOP_LOADER = "GLOBLE_PIN_STOP_LOADER";
